import { RootState } from "../../store";

export const sectionOpenedSelector = (rootState: RootState) =>
  rootState.menu.sectionOpened;
export const isOffcanvasSelector = (rootState: RootState) =>
  rootState.menu.isOffcanvas;
